<template>
  <v-dialog v-model="dialogHistorial" scrollable persistent max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">HISTORIAL DETALLE SOLICITUD</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text>
        <p v-if="historialDetalle.length === 0 && !cargandoHistorial" class="caption text-center">
          No hay historial disponible.
        </p>

        <v-simple-table v-else dense>
          <thead>
            <tr>
              <th class="px-2 caption">Estado Anterior</th>
              <th class="px-2 caption">Estado Actual</th>
              <th class="px-2 caption">Procesado Por</th>
              <th class="px-2 caption" style="min-width: 400px">Motivo</th>
              <th class="px-2 caption">Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in historialDetalle" :key="index">
              <td>{{ item.estado_anterior || '-' }}</td>
              <td>{{ item.estado_actual }}</td>
              <td>{{ item.procesado_por }}</td>
              <td>{{ item.motivo || '-' }}</td>
              <td>{{ formatearFecha(item.creado_en) }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="dialogHistorial = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import DetalleSolicitudService from './../services/detalle-solicitud';

export default {
  name: 'ModalVisualizarHistorialDetalleSolicitud',
  data() {
    return {
      dialogHistorial: false,
      cargandoHistorial: false,
      historialDetalle: [],
    };
  },
  methods: {
    abrir(detalleId) {
      this.verHistorial(detalleId);
    },
    async verHistorial(detalleId) {
      this.cargandoHistorial = true;
      this.historialDetalle = [];
      this.$emit('loadingStart');

      try {
        const response = await DetalleSolicitudService.obtenerHistorial(detalleId);
        const data = response?.data;
        const datos = data?.datos || [];

        this.historialDetalle = datos;
        this.dialogHistorial = true;

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'Historial obtenido correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.log(error);
        const mensaje = error.response.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al obtener el historial',
          type: 'error',
        });
      } finally {
        this.cargandoHistorial = false;
        this.$emit('loadingEnd');
      }
    },
    formatearFecha(fecha) {
      return moment(fecha).format('DD/MM/YYYY HH:mm:ss');
    },
  },
};
</script>